import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import { Row, Col } from 'react-bootstrap'
import 'react-alice-carousel/lib/alice-carousel.css'

class TimeHorizontalScroll extends React.Component {
  constructor(props) {
    super(props)
    this.responsive = {
      1024: { items: 7 },
      767: { items: 5 },
      570: { items: 4 },
      380: { items: 3 },
      0: { items: 3 },
    }
      this.state = { scrollIndex: 0 }
  }
    slidePrev=()=>this.Carousel.slidePrev()
    slideNext=()=> this.Carousel.slideNext()
    carouselRef=(el)=>this.Carousel = el
        
  onSlideChanged = (e) => {
    let leftArrow = document.querySelector('.collapse.show button[data-test-id="previous-arrow"]');
    let rightArrow = document.querySelector('.collapse.show button[data-test-id="next-arrow"]');
    let currentItem = e.item;
    let itemsIn = e.itemsInSlide
    let totalItems = this.props.timeSlots.length;
    if (leftArrow) {
      leftArrow.style.visibility = (!currentItem) ? "hidden" : "visible";
    }
    if (rightArrow) {
      rightArrow.style.visibility = ((currentItem + itemsIn) >= totalItems) ? "hidden" : "visible";
    }
    this.setState({ scrollIndex: e.item })

  }

  render() {
    let { timeSlots = [], displayNavButtons } = this.props;
    return (
      <>
        <fieldset>
          <legend className="visuallyhidden">Choose a Time</legend>
          <Row className="horizontal-scroll container">
            {displayNavButtons ? (
              <Col md={1}>
                <button
                  style={{ visibility: 'hidden' }}
                  aria-label="Scroll left to view additional times"
                  onClick={this.slidePrev}
                  data-test-id="previous-arrow"
                  className="scroll-arrow-container left-arrow  d-none d-md-block">
                  <svg focusable="false" className="svg-icon svg-icon-chevron">
                    <use xlinkHref="#icon-chevron"></use>
                  </svg>
                </button>
              </Col>
            ) : null}
            <Col md={10}>
              <div className="scroll-container ">
                <div aria-label="Available Time Slots" className="time-scroll" data-test-id="availability-scroll-container">

                  <AliceCarousel
                    mouseDragEnabled
                    responsive={this.responsive}
                    buttonsDisabled={true}
                    infinite={false}
                    aria-label="Available Time slots"
                    dotsDisabled={true}
                    items={getItems(timeSlots, this.props, this.Carousel)}
                    onSlideChanged={this.onSlideChanged}
                    slideToIndex={this.state.scrollIndex}
                    startIndex={this.state.scrollIndex}
                    ref={this.carouselRef}>
                  </AliceCarousel>

                </div>
              </div>
            </Col>
            {displayNavButtons ? (
              <Col md={1} className='arrow-scroll-container'>
                <button data-test-id="next-arrow" aria-label="Scroll right to view additional times" className="scroll-arrow-container ">
                  <svg

                    focusable="false"
                    onClick={this.slideNext}

                    className="svg-icon svg-icon-chevron">
                    <use xlinkHref="#icon-chevron"></use>
                  </svg>
                </button>
              </Col>
            ) : null}
          </Row>
        </fieldset>
      </>
    )
  }
}

const getItems = (timeSlots, props, carousel) => {
  return timeSlots.map((item) => (
    <button
      key={item}
      onClick={(e) => {
        props.onTimeSlotSelect(e);
        // if(carousel)
        //   carousel.slideTo(4);
      }}
      data-test-id="carousel-time-card"
      className={`${
        props.selectedTimeSlot === item ? 'selected-day-card' : ''
        }  carousel-time-card text-center  gotham-xn-medium filter-benefits-button`}>
      {item}
    </button>
  ))
}

export default TimeHorizontalScroll
